<span class="audit-indicator" *ngIf="audit">
  <button
    type="button"
    class="audit-trigger"
    (click)="toggle($event)"
    [attr.aria-label]="'Ver historial de ' + audit.fieldLabel"
    title="Ver último cambio"
  >
    <fa-icon [icon]="faClockRotateLeft" aria-hidden="true"></fa-icon>
  </button>
</span>
